import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  graphicDesignIcon,
  uiuxIcon,
  brandingIcon,
} from "../../../../assets/icons/serviceIcon/index";
import PrintAndMerchWork from "./PrintAndMerchWork";

const items = [
  {
    name: "Custom Print Collaterals",
    text: "From brochures and flyers to invites and thank-you cards, we design print assets that feel less like marketing and more like moments worth holding onto.",
  },
  {
    name: "Branded Merchandise Design",
    text: "Whether it’s mugs, tote bags, or clothes, we design merch that reflects your brand personality and adds real value to everyday life.",
  },
  {
    name: "Event & Corporate Gifting Kits",
    text: "For events, launches, and corporate giveaways, we design branded items that not only reflect your identity but also make a meaningful impact.",
  },
];

const otherService = [
  {
    icon: brandingIcon,
    name: "Branding & Identity",
    des: "Helping brands feel real, relatable, and ready to stand out.",
    path: "/branding-and-label",
  },
  {
    icon: uiuxIcon,
    name: "UI/UX Design",
    des: "Smooth, smart, and seamless experiences your users will love.",
    path: "/ui-ux-designing",
  },
  {
    icon: graphicDesignIcon,
    name: "Graphic Design",
    des: " Designs that don’t just look good, but make people stop and stare.",
    path: "/graphic-designing",
  },
];
const PrintAndMerch = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Design"
        description="Design you can touch, wear, gift, or hold -  that’s where print and merchandise come to life. We take your brand beyond the screen, creating moments that feel personal, memorable, and made to last. Because branding shouldn't stop at digital - it should travel with your audience, wherever they go."
        heading="Print & Merchandise"
      />
      <NewCommonServiceForm title="Print & Merchandise Design" items={items} />
      <PrintAndMerchWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default PrintAndMerch;
